import React from 'react';
import { ArrowUp, ArrowDown } from 'lucide-react';

export function KpiCard({
  label,
  value,
  trend,
  trendLabel,
  sub,
  icon: Icon,
  iconColor,
  className = '',
  onClick,
  active = false,
}) {
  const trendPositive = trend === 'up';
  const trendNegative = trend === 'down';
  const clickable = typeof onClick === 'function';
  const Wrapper = clickable ? 'button' : 'div';

  return (
    <Wrapper
      type={clickable ? 'button' : undefined}
      onClick={onClick}
      className={`w-full text-left bg-white border rounded-xl p-4 relative overflow-hidden transition ${
        active ? 'border-primary ring-1 ring-primary bg-primary/5' : 'border-slate-200'
      } ${clickable ? 'cursor-pointer hover:border-primary/50 hover:shadow-sm' : ''} ${className}`}
    >
      {/* Header */}
      {(Icon || label) && (
        <div className="flex items-center gap-2 text-[11.5px] text-slate-500 font-medium mb-1">
          {Icon && <Icon size={14} strokeWidth={1.75} className={iconColor} />}
          {label}
        </div>
      )}

      {/* Value */}
      <div className="text-2xl font-semibold tracking-tight tabular-nums text-slate-900">
        {value}
      </div>

      {/* Trend / Sub */}
      {(trendLabel || sub) && (
        <div
          className={`flex items-center gap-1 text-[11.5px] mt-0.5 ${
            trendPositive
              ? 'text-emerald-600'
              : trendNegative
              ? 'text-rose-600'
              : 'text-slate-500'
          }`}
        >
          {trendPositive && <ArrowUp size={12} strokeWidth={2} />}
          {trendNegative && <ArrowDown size={12} strokeWidth={2} />}
          {trendLabel || sub}
        </div>
      )}
    </Wrapper>
  );
}

export default KpiCard;
